import commonData from './commonData';
import projectsData from './projectsData';
import customDaysData from './customDaysData';
import resourcesData from './resourcesData';
import tasksData from './tasksData';
import workloadData from './workloadData';
import columnsData from './columnsData';
import timeTrackingData from './timeTrackingData';
import copyPasteData from './copyPasteData';

const GanttDataApi = {
  init(instance, ganttData = null) {
    instance.ganttDataApi = {};

    commonData(instance, ganttData); // adds methods to work with common store, masschange store, filter store and etc.
    projectsData(instance, ganttData); // adds methods to work with projects, ganttview and multiview models
    customDaysData(instance, ganttData); // adds methods to work with custom days model
    resourcesData(instance, ganttData); // adds methods to work with resources store
    tasksData(instance, ganttData); // adds methods to work with tasks store
    workloadData(instance, ganttData); // adds methods to work with workload
    columnsData(instance, ganttData); // adds methods to work with columns store
    timeTrackingData(instance, ganttData); // adds methods to work with time tracking model
    copyPasteData(instance, ganttData); // adds methods to work with time copypaste store
  },
};

export default GanttDataApi;
